
export function setup(readMoreLinkSelector, mainSectionSelector) {
    $(readMoreLinkSelector).show();
    $(mainSectionSelector).addClass('fade');
    $(readMoreLinkSelector).on('click', function (e) {
        e.preventDefault();
        $(mainSectionSelector).css('max-height', 'none');
        $(mainSectionSelector).height('auto');
        hide(readMoreLinkSelector, mainSectionSelector);
    });
}

export function hide(readMoreLinkSelector, mainSectionSelector) {
    $(readMoreLinkSelector).hide();
    if ($(readMoreLinkSelector).hasClass('mobile')) {
        $(readMoreLinkSelector).removeClass('mobile');
    }
    if ($(mainSectionSelector).hasClass('fade')) {
        $(mainSectionSelector).removeClass('fade');
    }
};
